import { createSlice } from "@reduxjs/toolkit";
import { getActivityListByWorkFlowID } from "api/activity";
const initialState = {
  activityList: [],
  loading: false,
  start: 0,
  limit: 10,
  sortBy: null,
  sortOrder: null,
  error: null,
  total: 0,
  updateStartValue:0,
};

export const activityListReducer = createSlice({
  name: "activityListReducer",
  initialState,
  reducers: {
    setStart: (state, action) => {
      state.start = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setSortOrder: (state, action) => {
      state.sortOrder = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setActivityList: (state, action) => {
      state.activityList = [...state.activityList, ...action.payload];
    },
    setTotal: (state, action) => {
      state.total = action.payload;
    },
    clearTotal: (state, action) => {
      state.total = 0;
    },
    clearActivityList: (state, action) => {
      state.activityList = [];
    },
    resetActivityListState: (state) => {
      state.activityList = [];
      state.loading = false;
      state.start = 0;
      state.limit = 10;
      state.sortBy = null;
      state.sortOrder = null;
      state.error = null;
      state.total = 0;
    },
    setupdateStartValue: (state, action) => {
      state.updateStartValue = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActivityListByWorkFlowID.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getActivityListByWorkFlowID.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.data.length === 0) {
          state.activityList = [];
        } else if (!state.activityList?.length) {
          state.activityList =
            Array.isArray(action.payload?.data) && action.payload?.data?.length
              ? [...action.payload.data]
              : [];
        } else {
          state.activityList = [...state.activityList, ...action.payload.data];
        }
        state.total = action.payload.count;
        state.error = null;
        state.start = state.start + state.limit;
      })
      .addCase(getActivityListByWorkFlowID.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

  },
});

export const {
  setStart,
  setLimit,
  setSortBy,
  setSortOrder,
  setError,
  setLoading,
  setActivityList,
  clearActivityList,
  resetActivityListState,
  clearTotal,
  setupdateStartValue,
} = activityListReducer.actions;

export default activityListReducer.reducer;
